import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import { getRouteName } from './helpers'
import configureStore from './configureStore'

export const store = configureStore()
export const history = syncHistoryWithStore(browserHistory, store)
export const getName = getRouteName(store)